import type { FaireProductEntity } from "../../entity_types/product";

export const p_16nl7gvpdx: FaireProductEntity = {
  token: "p_16nl7gvpdx",
  type: "product",
  name: "Custom Wine Bag (Your Logo / Your Own Design)",
  brandToken: "b_191br80oqs",
  brandName: "The Cotton & Canvas Co.",
  imageUrl: "https://cdn.faire.com/fastly/60439e5958196cd218748dc2968814e4e008fc5059842676f1519349ea9fcff4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/327159ce76e0ef2c5924b4e2a2ef318d3c5bcfcb7a83ed7ba886d0887039697b.jpeg",
    "https://cdn.faire.com/fastly/6b4fbd7b07e61c9042ab16ec160b1fcf8e9f4f0d4dfdc21bf775167be7babae2.jpeg",
    "https://cdn.faire.com/fastly/908230dd4dcb7bdce9c2d15e854f0ac98b6fa547443d69ba06891b99d1c97d15.jpeg",
    "https://cdn.faire.com/fastly/9cf50fddd68764892428e4b30b65ef69e71188a6ae3f37c673aa3fb0acc25398.jpeg"
  ],
  priceDollars: 7.5,
  description: "Customize this item with your artwork, logo or design!\n\nSimply submit your artwork and we'll print it for you! We kindly request the artwork to be in high resolution format. A PDF, EPS, PSD, or AI file is required to ensure the print is sharp and not pixelated. JPGs above 1000 pixels can be accepted.\n\nThese custom wine bags make the perfect gifts for the holidays, corporate events, client thank yous, birthdays, weddings and many more!\n\nTo purchase, kindly place your order and message us your artwork.\n\nA proof available upon request.\n\n• Material: 100% Heavy Duty Cotton Canvas Fabric (Natural Color, Not White)\n• Dimensions: 14\" H x 6.5\" W\n• Perfect gift for housewarmings, weddings, bridal showers, birthdays, and holidays\n• Fits a standard sized wine or champagne bottle\n• Designed and manufactured in the USA. Copyright The Cotton & Canvas Co.\n• All personalized item sales are final. Personalized items are non-refundable.",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:42.789Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
